// extracted by mini-css-extract-plugin
module.exports = {"noReport":"style__noReport__0Zx9p"};